import { render, staticRenderFns } from "./IconUpArrowFilled.vue?vue&type=template&id=141fe58e&scoped=true"
import script from "./IconUpArrowFilled.vue?vue&type=script&lang=js"
export * from "./IconUpArrowFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141fe58e",
  null
  
)

export default component.exports